import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
// Location
import WebdesignAgenturOesterreich from "./pages/WebdesignAgenturOesterreich";
import WebdesignAgenturKaernten from "./pages/WebdesignAgenturKaernten";
import WebdesignAgenturKlagenfurt from "./pages/WebdesignAgenturKlagenfurt";
import WebdesignAgenturVillach from "./pages/WebdesignAgenturVillach";
import WebdesignAgenturGraz from "./pages/WebdesignAgenturGraz";
import WebdesignAgenturWolfsberg from "./pages/WebdesignAgenturWolfsberg";
// Service
import ServiceWebdesign from "./pages/ServiceWebdesign";
import ServiceBranding from "./pages/ServiceBranding";
import ServiceCorporateDesign from "./pages/ServiceCorporateDesign";
import ServiceDigitaleStrategie from "./pages/ServiceDigitaleStrategie";
import ServiceWebsiteRelaunch from "./pages/ServiceWebsiteRelaunch";
// Industry
import WebdesignFuerAerzte from "./pages/WebdesignFuerAerzte";
import WebdesignFuerRestaurants from "./pages/WebdesignFuerRestaurants";
import WebdesignFuerHandwerker from "./pages/WebdesignFuerHandwerker";
import WebdesignFuerUnternehmen from "./pages/WebdesignFuerUnternehmen";
// Cost / Educational
import WebdesignKostenOesterreich from "./pages/WebdesignKostenOesterreich";
import BrandingKostenOesterreich from "./pages/BrandingKostenOesterreich";
import CostSocialMediaOesterreich from "./pages/CostSocialMediaOesterreich";
// Marketing (primary)
import MarketingDigitaleVermarktung from "./pages/MarketingDigitaleVermarktung";
import MarketingSocialMedia from "./pages/MarketingSocialMedia";
import MarketingOnlineMarketingUnternehmen from "./pages/MarketingOnlineMarketingUnternehmen";
import MarketingDigitaleMarkenpraesenz from "./pages/MarketingDigitaleMarkenpraesenz";
import ServiceWebsitesUnternehmen from "./pages/ServiceWebsitesUnternehmen";
// Marketing location
import MarketingAgenturOesterreich from "./pages/MarketingAgenturOesterreich";
import MarketingAgenturKaernten from "./pages/MarketingAgenturKaernten";
import SocialMediaAgenturKlagenfurt from "./pages/SocialMediaAgenturKlagenfurt";
import OnlineMarketingGraz from "./pages/OnlineMarketingGraz";
import DigitaleVermarktungWolfsberg from "./pages/DigitaleVermarktungWolfsberg";
import MarketingAgenturVillach from "./pages/MarketingAgenturVillach";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/digitale-vermarktung" element={<MarketingDigitaleVermarktung />} />
          <Route path="/social-media-marketing" element={<MarketingSocialMedia />} />
          <Route path="/online-marketing-fuer-unternehmen" element={<MarketingOnlineMarketingUnternehmen />} />
          <Route path="/digitale-markenpraesenz" element={<MarketingDigitaleMarkenpraesenz />} />
          <Route path="/websites-fuer-unternehmen" element={<ServiceWebsitesUnternehmen />} />
          <Route path="/marketing-agentur-oesterreich" element={<MarketingAgenturOesterreich />} />
          <Route path="/marketing-agentur-kaernten" element={<MarketingAgenturKaernten />} />
          <Route path="/social-media-agentur-klagenfurt" element={<SocialMediaAgenturKlagenfurt />} />
          <Route path="/online-marketing-graz" element={<OnlineMarketingGraz />} />
          <Route path="/digitale-vermarktung-wolfsberg" element={<DigitaleVermarktungWolfsberg />} />
          <Route path="/marketing-agentur-villach" element={<MarketingAgenturVillach />} />
          <Route path="/social-media-betreuung-kosten-oesterreich" element={<CostSocialMediaOesterreich />} />
          <Route path="/webdesign-agentur-oesterreich" element={<WebdesignAgenturOesterreich />} />
          <Route path="/webdesign-agentur-kaernten" element={<WebdesignAgenturKaernten />} />
          <Route path="/webdesign-agentur-klagenfurt" element={<WebdesignAgenturKlagenfurt />} />
          <Route path="/webdesign-agentur-villach" element={<WebdesignAgenturVillach />} />
          <Route path="/webdesign-agentur-graz" element={<WebdesignAgenturGraz />} />
          <Route path="/webdesign-agentur-wolfsberg" element={<WebdesignAgenturWolfsberg />} />
          <Route path="/webdesign" element={<ServiceWebdesign />} />
          <Route path="/branding" element={<ServiceBranding />} />
          <Route path="/corporate-design" element={<ServiceCorporateDesign />} />
          <Route path="/digitale-strategie" element={<ServiceDigitaleStrategie />} />
          <Route path="/website-relaunch" element={<ServiceWebsiteRelaunch />} />
          <Route path="/webdesign-fuer-aerzte" element={<WebdesignFuerAerzte />} />
          <Route path="/webdesign-fuer-restaurants" element={<WebdesignFuerRestaurants />} />
          <Route path="/webdesign-fuer-handwerker" element={<WebdesignFuerHandwerker />} />
          <Route path="/webdesign-fuer-unternehmen" element={<WebdesignFuerUnternehmen />} />
          <Route path="/webdesign-kosten-oesterreich" element={<WebdesignKostenOesterreich />} />
          <Route path="/branding-kosten-oesterreich" element={<BrandingKostenOesterreich />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
